// Per-account localStorage helpers.
//
// Keys used to be global to the browser, so a second account signing in on the
// same machine inherited the first one's last scores and weak words. Everything
// persisted per user now goes through here and gets a `:u<id>` suffix, with a
// `:guest` scope for visitors who are not signed in.

const GUEST_SCOPE = 'guest'

// Base keys, kept as they were before scoping so the legacy migration can find them
export const LAST_SCORES_KEY = 'lastScoresByLang'
export const UNKNOWN_WORDS_KEY = 'flashcardUnknownWords'
export const LAST_THEME_KEY = 'lastFlashcardTheme'

export function scopedKey(baseKey, userId) {
  return `${baseKey}:${userId ? `u${userId}` : GUEST_SCOPE}`
}

export function readScoped(baseKey, userId, fallback = {}) {
  try {
    const raw = localStorage.getItem(scopedKey(baseKey, userId))
    return raw === null ? fallback : JSON.parse(raw)
  } catch {
    // localStorage indisponible, ou contenu corrompu
    return fallback
  }
}

export function writeScoped(baseKey, userId, value) {
  try {
    localStorage.setItem(scopedKey(baseKey, userId), JSON.stringify(value))
  } catch {
    // localStorage indisponible (navigation privée, quota dépassé...)
  }
}

export function removeScoped(baseKey, userId) {
  try {
    localStorage.removeItem(scopedKey(baseKey, userId))
  } catch {
    // ignore
  }
}

// One-shot migration for data written before scoping existed: hand the orphan
// entry over to the first account that signs in on this browser, then drop it.
// Reserved for data that lives nowhere else (weak words) — last scores are
// simply discarded, since a single session rebuilds them.
export function adoptLegacyKey(baseKey, userId) {
  if (!userId) return
  try {
    const legacy = localStorage.getItem(baseKey)
    if (legacy === null) return
    // Never clobber data the account already accumulated post-migration
    if (localStorage.getItem(scopedKey(baseKey, userId)) === null) {
      localStorage.setItem(scopedKey(baseKey, userId), legacy)
    }
    localStorage.removeItem(baseKey)
  } catch {
    // ignore
  }
}

export function dropLegacyKey(baseKey) {
  try {
    localStorage.removeItem(baseKey)
  } catch {
    // ignore
  }
}
